module.exports = __webpack_public_path__ + "src/components/Favorite/circle.png?8fc6e1f9";


//////////////////
// WEBPACK FOOTER
// ./src/components/Favorite/circle.png
// module id = 2786
// module chunks = 1